export const formatCurrency = (value) => {
  if (value === undefined || value === null) return ''
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value)
}

export const parseCurrency = (value) => {
  if (!value) return 0
  return Number(value.replace(/\D/g, '')) / 100
}
